import PropTypes from 'prop-types';

export const TEAM_PLAYERS_DEF = {
  playerJerseyNumber: PropTypes.number.isRequired,
  playerFirstName: PropTypes.string.isRequired,
  playerLastName: PropTypes.string.isRequired,
};
